import { render } from "./PricingReviewInformation.vue?vue&type=template&id=62ffbfc1&scoped=true&ts=true"
import script from "./PricingReviewInformation.vue?vue&type=script&lang=ts"
export * from "./PricingReviewInformation.vue?vue&type=script&lang=ts"

import "./PricingReviewInformation.vue?vue&type=style&index=0&id=62ffbfc1&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ffbfc1"]])

export default __exports__